import { render, staticRenderFns } from "./introduce-news.vue?vue&type=template&id=a18af3a8&scoped=true&"
import script from "./introduce-news.vue?vue&type=script&lang=ts&"
export * from "./introduce-news.vue?vue&type=script&lang=ts&"
import style0 from "./introduce-news.vue?vue&type=style&index=0&id=a18af3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18af3a8",
  null
  
)

export default component.exports